<template>
  <svg
    width="23"
    height="14"
    viewBox="0 0 23 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.5 0H0.5V14H2.5V0ZM6.5 0H4.5V14H6.5V0ZM21.5 0H9.5C8.95 0 8.5 0.45 8.5 1V13C8.5 13.55 8.95 14 9.5 14H21.5C22.05 14 22.5 13.55 22.5 13V1C22.5 0.45 22.05 0 21.5 0ZM10.5 12H20.5V2H10.5V12Z"
      fill="#939393"
    />
  </svg>
</template>

<script>
/**
 * @fileoverview Templates Icon
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

export default {
  name: "TemplatesIcon",
};
</script>

<style lang="scss" scoped>
</style>